import { hasProblemImage } from "../../utils/problemImage";
import {
  hasProblemSource,
  noProblemSourceTitle,
} from "../../utils/problemSource";
import { Button } from "primereact/button";

// "Action" column (desktop): edit, delete, foto, lihat cek
const ProblemActionBody = ({
  row,
  permittedToEdit,
  onEdit,
  onDelete,
  onClickImage,
  onClickShowPengecekan,
}) => {
  return (
    <div className="row-center-center gap-2">
      <Button
        disabled={!permittedToEdit}
        icon="pi pi-pencil"
        rounded
        severity="success"
        className="bg-emerald-400 max-w-[1.85rem] max-h-[1.85rem]"
        onClick={() => {
          onEdit(row);
        }}
        pt={{ icon: { className: "!text-xs" } }}
      />
      <Button
        disabled={!permittedToEdit}
        icon="pi pi-trash"
        rounded
        severity="danger"
        className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
        onClick={() => {
          onDelete(row);
        }}
        pt={{ icon: { className: "!text-xs" } }}
      />

      <Button
        icon="pi pi-image"
        disabled={!hasProblemImage(row)}
        rounded
        className="max-w-[1.85rem] max-h-[1.85rem]"
        onClick={() => {
          onClickImage(row);
        }}
        pt={{ icon: { className: "!text-xs" } }}
      />

      {/* the title is on the span: a disabled button does not show a tooltip */}
      <span title={hasProblemSource(row) ? "Lihat Cek" : noProblemSourceTitle}>
        <Button
          icon="pi pi-eye"
          disabled={!hasProblemSource(row)}
          rounded
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            onClickShowPengecekan(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      </span>
    </div>
  );
};

export default ProblemActionBody;
